








































import TagModel from "@/ts/models/tagClass";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch
} from "@vue/composition-api";
import TagChip from "../../atoms/tag/TagChip.vue";
import CurrentOutlined from "@c/molecules/current/CurrentOutlined.vue";
import Draggable from "vuedraggable";

export default defineComponent({
  components: {
    TagChip,
    CurrentOutlined,
    Draggable
  },

  props: {
    tags: {
      type: Array as () => Array<TagModel>,
      default: () => []
    },
    label: {
      type: String,
      default: "Tags"
    },
    editable: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    }
  },

  name: "",

  setup(props, { emit }) {
    var compTags = ref<Array<TagModel>>([]);

    const setTags = (tags: Array<TagModel>) => {
      compTags.value = JSON.parse(JSON.stringify(tags));
    };

    onMounted(() => {
      setTags(props.tags);
    });

    watch(
      () => props.tags,
      newValue => {
        setTags(newValue);
      }
    );

    var drag = ref(false);

    var dragOptions: any = computed(() => {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    });

    const close = (index: number) => {
      const tag = compTags.value[index];
      emit("removeTag", index);
    };

    return {
      drag,
      dragOptions,
      compTags,
      close
    };
  }
});
